import { IconBell } from '@tabler/icons-react';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';

import { NavItemType } from '@app/types';

interface SidebarBottomItemsOptions {
  unreadCount: number;
  showAdmin: boolean;
  adminUrl: string;
  onNotificationsClick?: () => void;
  /** ZLAYT-1667: the admin switch for the Send feedback entry is on. */
  showFeedback?: boolean;
  onFeedbackClick?: () => void;
}

/**
 * The entries pinned to the bottom of the sidebar. My Documents is not here:
 * it sits under Home in the main menu (ZLAYT-1476), which is also the only
 * list drawn on narrow screens.
 */
export function sidebarBottomItems({
  unreadCount,
  showAdmin,
  adminUrl,
  onNotificationsClick,
  showFeedback = false,
  onFeedbackClick,
}: SidebarBottomItemsOptions): NavItemType[] {
  return [
    {
      id: 'notifications',
      title: 'Notifications',
      type: 'item',
      url: '/notifications',
      icon: IconBell,
      breadcrumbs: false,
      ...(unreadCount > 0 && {
        chip: {
          label: `${unreadCount}`,
          color: 'primary',
        },
      }),
      customAction: onNotificationsClick,
    },
    ...(showAdmin
      ? [
          {
            id: 'super-admin-panel',
            title: 'Super Admin',
            type: 'item',
            // A firm account cannot open the super admin landing tab.
            url: adminUrl,
            icon: ShieldOutlinedIcon,
            breadcrumbs: false,
          },
        ]
      : []),
    ...(showFeedback
      ? [
          {
            id: 'send-feedback',
            title: 'Send feedback',
            type: 'item',
            url: '#',
            icon: FeedbackOutlinedIcon,
            breadcrumbs: false,
            customAction: onFeedbackClick,
          },
        ]
      : []),
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/settings/personal-info',
      icon: SettingsOutlinedIcon,
      breadcrumbs: false,
    },
  ];
}
